module.exports = "<div class=row id=home> <div class=col-md-12> <div class=row ng-if=!user> <img src=/images/banner.png id=banner class=col-sm-12 /> <login id=login></login> </div> <div class=row> <overdue-treatments ng-if=user></overdue-treatments> </div> <div class=row> <news class=col-md-12></news> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp-files/modules/app/views/main.html
// module id = 345
// module chunks = 0